import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=6ca3b384&scoped=true&"
import script from "./Zoom.vue?vue&type=script&lang=js&"
export * from "./Zoom.vue?vue&type=script&lang=js&"
import style0 from "./Zoom.vue?vue&type=style&index=0&id=6ca3b384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca3b384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca3b384')) {
      api.createRecord('6ca3b384', component.options)
    } else {
      api.reload('6ca3b384', component.options)
    }
    module.hot.accept("./Zoom.vue?vue&type=template&id=6ca3b384&scoped=true&", function () {
      api.rerender('6ca3b384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/Zoom.vue"
export default component.exports